import { defineStore } from 'pinia'
import VLApi from '@/api/VLApi';
import servicesAPI from '@/api/servicesAPI';
import { jwtDecode } from 'jwt-decode';

//Import pinia stores
import { useWebportalStore } from './webportal';
import { useDebtorStore } from './debtor';
import { useFeedbackStore } from './feedback';
import { useMenuStore } from './menu';
import { useLaundryStore } from './laundry';
import { useOnlineStore } from './online';

//Import models
import { LoginPayload } from '@/models/LoginPayload'


//Setup store
export const useAuthStore = defineStore('auth', {
    state: () => ({
        VLtoken: localStorage.getItem('VlApiToken') || null,
        servicesToken: localStorage.getItem('VlServiceToken') || null,
    }),
    actions: {
        //Authenticate user and get token and set it in localStorage
        async login(payload: LoginPayload) {
            if (!useOnlineStore().online) {
                useFeedbackStore().setTranslatedMessage('danger', 'noInternet');
                return false;
            }

            if (!useWebportalStore()?.selectedWebportal?.ServiceUrl) {
                await this.logout();
                return false;
            }

            try {
                //Encrypt token
                // eslint-disable-next-line
                const token = btoa(`${payload.username}:${payload.password}`);
                
                //Set ServicesToken in store and localStorage
                this.servicesToken = token;
                localStorage.setItem('VlServiceToken', token);

                //Check if credentials exist at selected webportal
                await servicesAPI.post(`${useWebportalStore()?.selectedWebportal?.ServiceUrl ?? ''}/Greet`, {}, {
                    headers: {
                        'Authorization': `Basic ${token}`
                    }
                });

                //Get Laundry
                await useLaundryStore().getLaundry();

                const vlApiResponse = await VLApi.post(`${useWebportalStore().vlApiUrl}/auth/authenticate-webportal`, payload);

                //Set VLToken in store and localStorage
                this.VLtoken = vlApiResponse.data.data;
                localStorage.setItem('VlApiToken', vlApiResponse.data.data);

                useFeedbackStore().setTranslatedMessage('success', 'successLogin');

                //Get menuItems
                await useMenuStore().getMenuItems();
                
                //Get debtors
                await useDebtorStore().getDebtors();

                return true;
            } catch (error: any) {
                useFeedbackStore().setTranslatedMessage('danger', 'unsuccessLogin');
                return false;
            }
        },

        
        //Authenticate user and get token and set it in localStorage
        async resetPassword(payload: {username: string, email: string}) {
            if (!useOnlineStore().online) {
                useFeedbackStore().setTranslatedMessage('danger', 'noInternet');
                return false;
            }

            if (!useWebportalStore()?.selectedWebportal?.ServiceUrl) {
                await this.logout();
                return false;
            }

            try {
                const token = btoa(`${payload.username}:${" "}`);
                
                //Set ServicesToken in store and localStorage
                this.servicesToken = token;
                const result = await servicesAPI.post(`${useWebportalStore()?.selectedWebportal?.ServiceUrl ?? ''}/GetWachtwoordVergeten`, {
                    ...payload,
                    api: 2
                }, {
                    headers: {
                        'Authorization': `Basic ${token}`
                    }
                });
                if (result.data.Successful) {
                    useFeedbackStore().setTranslatedMessage('success', 'successResetPasswordSent');
                    return true;    
                } else {
                    useFeedbackStore().setTranslatedMessage('danger', 'unsuccessResetPasswordSent');
                    return false;
                }
                
            } catch (error: any) {
                useFeedbackStore().setTranslatedMessage('danger', 'unsuccessResetPasswordSent');
                return false;
            }
        },

        //Delete tokens from localStorage
        async logout() {
            localStorage.removeItem('VlApiToken');
            localStorage.removeItem('VlServiceToken');
            localStorage.removeItem('laundry');
            localStorage.removeItem('route');
            localStorage.removeItem('menuAutoOpened'); // Clear menu auto-open flag
            this.VLtoken = null;
            this.servicesToken = null;
        }
    },
    getters: {
        dragerLogin: (state) => {
            return !!(state.VLtoken && (jwtDecode(state.VLtoken) as any).Drager)
        },
        drager: (state) => {
            return (state.VLtoken ? (jwtDecode(state.VLtoken) as any).Drager : null)
        }
    }
})